<template>
  <div class="asc-plots-grid--holder">
    <asc-ag-grid-filter
      :key="`asc-plots-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscDrillDownCellRenderer,
  AscDeleteCellRenderer,
} from '@/components/agGrid'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFormattedDateTime } from '@/utilities/dates'

export default {
  name: 'AscPlotsGrid',

  components: {
    AscAgGridFilter,
    AscDrillDownCellRenderer,
    AscDeleteCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    deleting: {
      type: Boolean,
      default: false,
    },
    onOpenSavedPlot: {
      type: Function,
      default: () => {},
    },
    onDeleteSavedPlot: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          floatingFilter: false,
        },
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values.filter(item => !item.isDeleting)
    },
    agGridRowData() {
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'Plot Title',
          field: 'title',
          cellClass: ['ag-cell--drill', 'ag-cell--drill-ripple'],
          cellRenderer: 'AscDrillDownCellRenderer',
        },
        {
          headerName: 'Date Saved',
          field: 'dateSaved',
          width: 155,
          minWidth: 155,
          sort: 'desc',
          valueFormatter: data => getFormattedDateTime(data.value),
          comparator: this.sortDate,
        },
        {
          headerName: '',
          field: 'id',
          cellRenderer: 'AscDeleteCellRenderer',
          cellRendererParams: {
            handleDelete: this.onDeleteSavedPlot,
            disabled: this.deleting,
          },
          width: 44,
          minWidth: 44,
          maxWidth: 44,
          sortable: false,
        },
      ]
    },
  },

  methods: {
    handleCellClicked(event) {
      if (event) {
        const field = event.colDef.field
        switch (field) {
          case 'title': {
            if (this.onOpenSavedPlot) {
              const id = event.data.id
              const title = event.value
              this.onOpenSavedPlot(id, title)
            }
            break
          }
          default:
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}
</style>
